export default __webpack_public_path__ + "static/media/credit_card.611b7740.svg";